import { YAxis } from "recharts";

const BaseYAxis = YAxis

export default BaseYAxis;